import { useMemo } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- this is where it's overridden
import { SimpleForm as RaSimpleForm, type SimpleFormProps } from 'react-admin';

import { composeValidationResolver } from '@sh4res/bo-common/validators';

/**
 * Drop-in replacement for react-admin's `SimpleForm` that keeps the `validate` prop
 * of the inputs working when the form itself declares a `validate` prop.
 *
 * react-admin converts a form level `validate` into a react-hook-form `resolver`, and
 * react-hook-form runs either the resolver or the rules registered by the fields, never
 * both — so a form level `validate` silently disables every input level validator.
 * See `composeValidationResolver`.
 */
export const SimpleForm = ({ validate, resolver, ...props }: SimpleFormProps) => {
  const finalResolver = useMemo(
    () => resolver ?? (validate ? composeValidationResolver(validate) : undefined),
    [resolver, validate],
  );

  return <RaSimpleForm {...props} resolver={finalResolver} />;
};
